module.exports = __webpack_public_path__ + "img/transport.92a04f1.svg";